import { AnswerSchema, PromptStepSchema } from '@feedyou/schema'

import { search } from './services/search'
import { unsetDialogs } from './services/unsetDialogs'
import { getUsedDialogs } from './services/getUsedDialogs'
import { createStepService } from '../../utils/stepServices/createStepServices'
import { getSubdialogConnectionsMetadata } from './services/getSubdialogConnectionsMetadata'

export const promptStepService = createStepService<PromptStepSchema, {}>({
  search,

  unsetDialogs,
  getUsedDialogs,
  getSubdialogConnectionsMetadata
})
